import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import moment from "moment";
import { Form } from "react-bootstrap";
import { selectGymData } from "../../../../../redux/reducers/gymDataSlice";
import SelectDropdown from "../../../../components-react/SelectDropdown";
import { createFetchPlans } from "../../../../../redux/reducers/postApiSlice";
import {
  convertThenFormat,
  convertToYYYYMMDD,
  currentDateOfTheMonth,
  currentMonthCurrentDate,
} from "../../../../common-data/Converts";
import { commonPostPutApi } from "../../../../../redux/reducers/commonApiSlice";
import {
  add_df_payment,
  couple_post_deffered_payment_request,
} from "../../../../../data/ApiEndpoints";
import { showConfirmAlert } from "../../../../components-react/ReactAlert";
import VerifyRegisterMember from "../../../../deffered-payments/verify-register-member/VerifyRegisterMember";
import {
  df_payment_modes,
  partialPaymentModes,
} from "../../../../common-data/DropdowData";
import { validateForm } from "./validatePaymentForm";
import { fetchIndividualTypeData } from "../../../../../redux/reducers/dropdownApiSlice";
import CloseSubmitBtn from "../../../../common-components/custom-comps/CloseSubmitBtn";
import { fetchGymData } from "../../../../../data/APIs";

const PaymentLinkForm = ({
  closeModal,
  callFunction,
  userInfoData,
  rowData,
  paymentType, // 'discount' or 'deferred'
}) => {
  const dispatch = useDispatch();
  const gymData = useSelector(selectGymData);
  const { postPutLoading } = useSelector((state) => state.common);
  const { individualData } = useSelector(
    (state) => state.dropdown
  );

  const isAdmin = userInfoData?.account_type === "admin";
  const isClusterManager = userInfoData?.account_type === "cluster_manager";

  const [regularPlans, setRegularPlans] = useState([]);
  const [planPrices, setPlanPrices] = useState([]);

  const iniFormValues = {
    selectedGym:
      rowData?.gym_name && rowData?.gym_id
        ? {
            label: rowData.gym_name,
            value: rowData.gym_id,
          }
        : !isAdmin && userInfoData?.gym_name && userInfoData?.gym_id
        ? {
            label: userInfoData.gym_name,
            value: userInfoData.gym_id,
          }
        : "",
    memberName: rowData?.name || "",
    memberMobile: rowData?.mobile || "",
    memberEmail: rowData?.email || "",
    memberGender: rowData?.gender || "",
    memberDOB: rowData?.dob ? convertToYYYYMMDD(rowData.dob) : "",

    selectedPlan: "",
    selectedPlanIndex: "",
    selectedPrice: "",
    selectedExtendedDays: "",
    finalBaseAmount: "",
    selectedSubsStartDate: "",
    selectedSubsEndDate: "",

    memberMobile2: "",
    memberName2: "",
    memberEmail2: "",
    memberGender2: "",
    memberDOB2: "",
    member2Info: "",

    selectedPaymentMode: "",
    cashAmount: "",
    onlineAmount: "",
    selectedFirstPartialPaymentMode: "",
    firInsAmount: "",
    secInsAmount: "",
    thiInsAmount: "",
    firInsDate: currentDateOfTheMonth,
    secInsDate: "",
    thiInsDate: "",

    isCouplePlan: false,
  };
  const [formValues, setFormValues] = useState(iniFormValues);
  const formRef = useRef({});
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);
  const [isMemberVerified, setIsMemberVerified] = useState(false);

  const onChangeInput = (e) => {
    const { name, value, type, checked } = e.target;

    setIsSubmit(false);

    const isDual = formValues.selectedPaymentMode?.value === "dual";
    const selectedAmount = Number(formValues.selectedPrice?.label || 0);

    if (isDual && selectedAmount && name === "cashAmount") {
      const onlineAmount =
        selectedAmount > value ? selectedAmount - Number(value || 0) : 0;

      setFormValues((prevs) => ({
        ...prevs,
        onlineAmount: onlineAmount,
        [name]: value,
      }));
    } else if (isDual && selectedAmount && name === "onlineAmount") {
      const cashAmount =
        selectedAmount > value ? selectedAmount - Number(value || 0) : 0;

      setFormValues((prevs) => ({
        ...prevs,
        cashAmount: cashAmount,
        [name]: value,
      }));
    } else if (
      name === "selectedSubsStartDate" &&
      formValues.selectedPlan?.info
    ) {
      setFormValues((prevs) => {
        const planDuration = Number(prevs.selectedPlan?.info?.duration || 0);
        const subsEndDate =
          value && planDuration
            ? moment(value, "YYYY-MM-DD")
                .tz("Asia/Kolkata")
                .add(planDuration, "days")
                .format("YYYY-MM-DD")
            : "";

        return {
          ...prevs,
          selectedSubsEndDate: subsEndDate,
          [name]: value,
        };
      });
    } else if (name === "isCouplePlan") {
      onChangeDropdown("", "selectedPlan");
      setFormValues((prevs) => ({
        ...prevs,
        [name]: checked,
      }));
    } else {
      setFormValues((prevs) => ({
        ...prevs,
        [name]: type === "checkbox" ? checked : value,
      }));
    }
  };

  const onChangeDropdown = (value, name) => {
    if (name === "selectedGym") {
      setFormValues((prevs) => ({
        ...prevs,
        selectedPlan: "",
        selectedPlanIndex: "",
        selectedPrice: "",
        selectedExtendedDays: "",
        finalBaseAmount: "",
        selectedSubsStartDate: "",
        selectedSubsEndDate: "",
        selectedPaymentMode: "",
        selectedFirstPartialPaymentMode: "",

        memberMobile2: "",
        memberName2: "",
        memberEmail2: "",
        memberGender2: "",
        memberDOB2: "",
        member2Info: "",

        [name]: value,
      }));

      setRegularPlans([]);
      setPlanPrices([]);
      setIsMemberVerified(false);
    } else if (formValues.selectedSubsStartDate && name === "selectedPlan") {
      const planDuration = Number(value?.info?.duration || 0);
      const startDate = formValues.selectedSubsStartDate;
      const subsEndDate =
        startDate && planDuration
          ? moment(startDate, "YYYY-MM-DD")
              .tz("Asia/Kolkata")
              .add(planDuration, "days")
              .format("YYYY-MM-DD")
          : "";

      setFormValues((prevs) => ({
        ...prevs,
        selectedPlanIndex: "",
        selectedPrice: "",
        selectedExtendedDays: "",
        finalBaseAmount: value?.info?.base_price || 0,
        selectedPaymentMode: "",
        selectedFirstPartialPaymentMode: "",
        selectedSubsEndDate: subsEndDate,
        [name]: value,
      }));

      setIsMemberVerified(false);
    } else if (name === "selectedPlan") {
      setFormValues((prevs) => ({
        ...prevs,
        selectedPlanIndex: "",
        selectedPrice: "",
        selectedExtendedDays: "",
        finalBaseAmount: value?.info?.base_price || 0,
        selectedPaymentMode: "",
        selectedFirstPartialPaymentMode: "",
        selectedSubsStartDate: "",
        selectedSubsEndDate: "",

        memberMobile2: "",
        memberName2: "",
        memberEmail2: "",
        memberGender2: "",
        memberDOB2: "",
        member2Info: "",

        [name]: value,
      }));
    } else {
      setFormValues((prevs) => ({
        ...prevs,
        [name]: value,
      }));
    }
  };

  const handleSelectPlan = (index, amount, planId, planInfo) => {
    if (index === formValues.selectedPlanIndex) {
      setFormValues((prev) => ({
        ...prev,
        selectedPlanIndex: "",
        selectedPrice: {
          value: "",
          label: "",
          info: "",
        },
        selectedExtendedDays: "",
      }));
    } else {
      const extendedDaysNumber = planInfo?.extend_days || 0;

      const newState = {
        ...formValues,
        selectedPlanIndex: index,
        selectedPrice: {
          value: planId,
          label: amount,
          info: planInfo,
        },
        selectedExtendedDays: {
          label: extendedDaysNumber,
          value: extendedDaysNumber,
        },
      };

      setFormValues(newState);
    }
  };

  const handleCreateFetchPlans = async (userData, TOKEN) => {
    try {
      const actionResult = dispatch(createFetchPlans({ userData, TOKEN }));
      const result = await actionResult;

      if (result?.payload?.status && result?.payload?.data?.length > 0) {
        const planData = result.payload.data || [];

        const allPlansDropdownData =
          planData?.length > 0
            ? planData.map((plan) => {
                return {
                  label: `${plan.plan_name}/${plan.duration}Days`,
                  value: plan.plan_uid,
                  is_couple: plan?.couple_included,
                  info: plan,
                };
              })
            : [];

        setRegularPlans(allPlansDropdownData);
      } else {
        setRegularPlans([]);
        const errorMessage = result?.error?.message;
        console.log("errorMessage=> ", errorMessage);
      }
    } catch (error) {
      console.log("handleCreateFetchPlans ERROR => ", error);
    }
  };

  function getAllAdmins(gymId) {
    dispatch(
      fetchIndividualTypeData({
        token: userInfoData?.token,
        qps: `account_type=receptionist,trainer&gym_id=${gymId}`,
        pageNo: 1,
        limit: 100,
      })
    );
  }

  const handleSubmitForm = async (payload) => {
    const method = "POST";
    const endpoint =
      formValues.selectedPlan?.is_couple && isMemberVerified
        ? couple_post_deffered_payment_request
        : add_df_payment;
    const token = userInfoData?.token || "";

    try {
      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload, token })
      );

      if (result?.payload?.status) {
        toast.success(result?.payload?.message || "Payment link sent successfully!");
        setIsSubmit(false);
        setFormValues(iniFormValues);
        callFunction();
        closeModal();
      } else {
        const errorMessage = result?.payload?.message || result?.error?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making POST request:", error);
    }
  };

  const onSubmit = () => {
    const errors = validateForm(formValues);
    setFormErrors(errors);
    setIsSubmit(true);

    if (formRef.current) {
      const firstErrorField = Object.keys(errors).find(
        (field) => formRef.current[field]
      );

      if (firstErrorField) {
        formRef.current[firstErrorField].scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    }
  };

  const assignRef = (fieldName) => (el) => {
    if (!formRef.current) {
      formRef.current = {};
    }

    if (el) {
      formRef.current[fieldName] = el;
    }
  };

  // Fetch gym data on mount
  useEffect(() => {
    dispatch(fetchGymData(userInfoData?.token));
  }, []);

  useEffect(() => {
    if (formValues.selectedGym?.value) {
      handleCreateFetchPlans(
        {
          gym_id: formValues.selectedGym.value,
          couple_included: formValues.isCouplePlan ? 1 : 0,
        },
        userInfoData?.token
      );
    }
  }, [formValues.selectedGym, formValues.isCouplePlan]);

  useEffect(() => {
    getAllAdmins(formValues.selectedGym?.value || "");
  }, [formValues.selectedGym]);

  useEffect(() => {
    if (formValues.selectedPlan?.info) {
      const priceDetailsArray =
        formValues.selectedPlan.info?.price_details || [];
      setPlanPrices(priceDetailsArray);
    } else {
      setPlanPrices([]);
    }
  }, [formValues.selectedPlan]);

  useEffect(() => {
    const isPartial = formValues.selectedPaymentMode?.value === "partial";

    if (
      isPartial &&
      formValues.selectedPlan?.info &&
      formValues.selectedPrice?.label &&
      formValues.selectedSubsStartDate
    ) {
      const planInfo = formValues.selectedPlan?.info || {};
      const selectedAmount = Number(formValues.selectedPrice?.label || 0);

      let firstInstallmentDate = "",
        secondInstallmentDate = "",
        thirdInstallmentDate = "";

      const firstEmiPercentage = Number(planInfo.first_emi_percentage) || 0;
      const secondEmiPercentage = Number(planInfo.second_emi_percentage) || 0;
      const thirdEmiPercentage = Number(planInfo.third_emi_percentage) || 0;

      const firstInstallmentAmount =
        (selectedAmount * firstEmiPercentage) / 100;
      const secondInstallmentAmount =
        (selectedAmount * secondEmiPercentage) / 100;
      const thirdInstallmentAmount =
        (selectedAmount * thirdEmiPercentage) / 100;

      const { second_emi_duration, third_emi_duration } = planInfo;

      firstInstallmentDate = moment(
        formValues.selectedSubsStartDate,
        "YYYY-MM-DD"
      )
        .tz("Asia/Kolkata")
        .add(1, "days")
        .format("YYYY-MM-DD");
      secondInstallmentDate = moment(firstInstallmentDate, "YYYY-MM-DD")
        .tz("Asia/Kolkata")
        .add(second_emi_duration, "days")
        .format("YYYY-MM-DD");
      thirdInstallmentDate = moment(secondInstallmentDate, "YYYY-MM-DD")
        .tz("Asia/Kolkata")
        .add(third_emi_duration, "days")
        .format("YYYY-MM-DD");

      setFormValues((prev) => ({
        ...prev,
        firInsAmount: firstInstallmentAmount,
        secInsAmount: secondInstallmentAmount,
        thiInsAmount: thirdInstallmentAmount,
        secInsDate: secondInstallmentDate,
        thiInsDate: thirdInstallmentDate,
      }));
    } else {
      setFormValues((prev) => ({
        ...prev,
        firInsAmount: "",
        secInsAmount: "",
        thiInsAmount: "",
        secInsDate: "",
        thiInsDate: "",
      }));
    }
  }, [
    formValues.selectedPaymentMode,
    formValues.selectedPlan,
    formValues.selectedPrice,
    formValues.selectedSubsStartDate,
  ]);

  useEffect(() => {
    if (isSubmit && Object.keys(formErrors)?.length === 0) {
      const isPartial = formValues.selectedPaymentMode?.value === "partial";
      const isDual = formValues.selectedPaymentMode?.value === "dual";

      const userData = {
        created_by: userInfoData?.user_id || userInfoData?.uid || "",
        user_id: rowData?.uid || rowData?.user_id || "",
        gym_id: formValues.selectedGym?.value || "",
        plan_id: formValues.selectedPlan?.value || "",
        plan_price: formValues.selectedPrice?.label || "",
        extend_days: formValues.selectedExtendedDays?.value || "",
        start_date: formValues.selectedSubsStartDate || "",
        expire_date: formValues.selectedSubsEndDate || "",

        requested_by: formValues.selectedRequestedBy?.value ?? "",

        payment_mode: isDual
          ? "cash/online"
          : formValues.selectedPaymentMode?.value || "",
        cash_amount: isDual ? formValues.cashAmount || "" : "",
        online_amount: isDual ? formValues.onlineAmount || "" : "",
        first_payment_mode: isPartial
          ? formValues.selectedFirstPartialPaymentMode?.value || ""
          : "",
        partial_payment_details: isPartial
          ? [
              {
                user_id: rowData?.uid || rowData?.user_id || "",
                amount: formValues.firInsAmount || "",
                date: formValues.firInsDate || "",
                payment_mode:
                  formValues.selectedFirstPartialPaymentMode?.value || "",
                status: "completed",
                subscription_id: "",
                date_added: "",
                order_id: "",
                payment_id: "",
              },
              {
                user_id: rowData?.uid || rowData?.user_id || "",
                amount: formValues.secInsAmount || "",
                date: formValues.secInsDate || "",
                payment_mode: "",
                subscription_id: "",
                status: "",
                date_added: "",
                order_id: "",
                payment_id: "",
              },
            ]
          : [],
      };

      const userDataCouplePlan = {
        req_body: {
          created_by: userInfoData?.user_id || userInfoData?.uid || "",
          user_id: rowData?.uid || rowData?.user_id || "",
          gym_id: formValues.selectedGym?.value || "",
          plan_id: formValues.selectedPlan?.value || "",
          plan_price: formValues.selectedPrice?.label || "",
          extend_days: formValues.selectedExtendedDays?.value || "",
          start_date: formValues?.selectedSubsStartDate || "",
          expire_date: formValues?.selectedSubsEndDate || "",
          requested_by: formValues.selectedRequestedBy?.value || "",

          payment_mode: isDual
            ? "cash/online"
            : formValues.selectedPaymentMode?.value || "",
          cash_amount: isDual ? formValues.cashAmount || "" : "",
          online_amount: isDual ? formValues.onlineAmount || "" : "",
          first_payment_mode: isPartial
            ? formValues.selectedFirstPartialPaymentMode?.value || ""
            : "",
          partial_payment_details: isPartial
            ? [
                {
                  user_id: rowData?.uid || rowData?.user_id || "",
                  amount: formValues.firInsAmount || "",
                  date: formValues.firInsDate || "",
                  payment_mode:
                    formValues.selectedFirstPartialPaymentMode?.value || "",
                  status: "completed",
                  subscription_id: "",
                  date_added: "",
                  order_id: "",
                  payment_id: "",
                },
                {
                  user_id: rowData?.uid || rowData?.user_id || "",
                  amount: formValues.secInsAmount || "",
                  date: formValues.secInsDate || "",
                  payment_mode: "",
                  subscription_id: "",
                  status: "",
                  date_added: "",
                  order_id: "",
                  payment_id: "",
                },
              ]
            : [],
        },

        user_id_1: rowData?.uid || rowData?.user_id || "",
        user_id_2:
          formValues.member2Info?.uid || formValues.member2Info?.user_id || "",
      };

      const handleConfirm = async () => {
        handleSubmitForm(
          formValues.selectedPlan?.is_couple && isMemberVerified
            ? userDataCouplePlan
            : userData
        );
      };

      showConfirmAlert(
        handleConfirm,
        `Are you sure!`,
        "Cancel",
        "Send Link"
      );
    }
  }, [isSubmit, formErrors]);

  return (
    <div className="lms-pm-links-form-container">
      <form className="formContainer">
        <div className="formInputsGrid threeGridSystem">
          <div className="formInputBox span2">
            <label htmlFor="selectedGym" className={`formInputLabel`}>
              gym name <span className="required">*</span>
            </label>

            <div
              className={`commonWrapper ${
                formErrors.selectedGym ? "formError" : ""
              }`}
              ref={assignRef("selectedGym")}>
              <SelectDropdown
                name="Gym"
                options={gymData?.length > 0 ? gymData : []}
                selectedOption={formValues.selectedGym}
                setSelectedOption={(selectedValue) =>
                  onChangeDropdown(selectedValue, "selectedGym")
                }
                isDisable={
                  isAdmin || isClusterManager
                    ? false
                    : formValues.selectedGym?.value
                }
              />
            </div>

            <span className="error-label">{formErrors?.selectedGym || ""}</span>
          </div>

          <div className="formInputBox">
            <label htmlFor="selectedPlan" className="formInputLabel">
              regular Plans <span className="required">*</span>
            </label>

            <div
              className={`commonWrapper ${
                formErrors.selectedPlan ? "formError" : ""
              }`}
              ref={assignRef("selectedPlan")}>
              <SelectDropdown
                options={regularPlans}
                selectedOption={formValues.selectedPlan}
                setSelectedOption={(selectedValue) =>
                  onChangeDropdown(selectedValue, "selectedPlan")
                }
                name="Plan"
              />
            </div>

            <Form.Check
              type="checkbox"
              name="isCouplePlan"
              className={`${formErrors?.isCouplePlan ? "formError" : ""}`}
              style={{
                cursor: "pointer",
              }}
              label={`Couple Plan`}
              checked={formValues.isCouplePlan}
              onChange={onChangeInput}
            />

            <span className="error-label">
              {formErrors?.selectedPlan || ""}
            </span>
          </div>

          {formValues.selectedPlan?.is_couple ? (
            <VerifyRegisterMember
              userInfoData={userInfoData}
              formValues={formValues}
              setFormValues={setFormValues}
              formErrors={formErrors}
              setFormErrors={setFormErrors}
              isMemberVerified={isMemberVerified}
              setIsMemberVerified={setIsMemberVerified}
              assignRef={assignRef}
            />
          ) : null}

          {(formValues.selectedPlan?.is_couple && isMemberVerified) ||
          (formValues.selectedPlan && !formValues.selectedPlan?.is_couple) ||
          formValues.selectedSession ? (
            <>
              <div className="formInputBox">
                <label htmlFor="memberMobile2" className="formInputLabel">
                  Subscription start date <span className="required">*</span>
                </label>

                <input
                  type="date"
                  name="selectedSubsStartDate"
                  ref={assignRef("selectedSubsStartDate")}
                  className={`formInput ${
                    formErrors.selectedSubsStartDate ? "formError" : ""
                  } ${
                    formValues.selectedSubsStartDate ? "date-has-value" : ""
                  }`}
                  value={formValues.selectedSubsStartDate}
                  onChange={onChangeInput}
                  min={currentMonthCurrentDate}
                />

                <span className="error-label">
                  {formErrors.selectedSubsStartDate || ""}
                </span>
              </div>

              {formValues.selectedSubsEndDate && (
                <div className="formInputBox">
                  <label
                    htmlFor="selectedSubsEndDate"
                    className="formInputLabel">
                    Subscription expire date
                  </label>

                  <input
                    type="date"
                    name="selectedSubsEndDate"
                    ref={assignRef("selectedSubsEndDate")}
                    className={`formInput ${
                      formErrors.selectedSubsEndDate ? "formError" : ""
                    } ${
                      formValues.selectedSubsEndDate ? "date-has-value" : ""
                    }`}
                    value={formValues.selectedSubsEndDate}
                    onChange={onChangeInput}
                    disabled
                  />

                  <span className="error-label">
                    {formErrors.selectedSubsEndDate || ""}
                  </span>
                </div>
              )}

              <div className="formInputBox">
                <label htmlFor="selectedRequestedBy" className="formInputLabel">
                  requested by <span className="not required">(Optional)</span>
                </label>

                <div
                  className={`commonWrapper ${
                    formErrors.selectedRequestedBy ? "formError" : ""
                  }`}
                  ref={assignRef("selectedRequestedBy")}>
                  <SelectDropdown
                    options={
                      individualData && individualData?.length > 0
                        ? individualData
                        : []
                    }
                    selectedOption={formValues.selectedRequestedBy}
                    setSelectedOption={(selectedValue) =>
                      onChangeDropdown(selectedValue, "selectedRequestedBy")
                    }
                    name="requested by"
                  />
                </div>

                <span className="error-label">
                  {formErrors.selectedRequestedBy || ""}
                </span>
              </div>

              {formValues.selectedPlan && (
                <>
                  <div className="formInputBox span3">
                    <label htmlFor="selectedPrice" className="formInputLabel">
                      Available Plan Price <span className="required">*</span>
                    </label>

                    {planPrices?.length > 0 ? (
                      <div
                        className={`flexWrapMultiBoxontainerSub mb-rg3rem ${
                          formErrors.selectedPrice ? "formError" : ""
                        }`}
                        style={{
                          border: "1px solid #c2c2c2",
                          boxShadow: "none",
                          background: "#fff",
                        }}>
                        {planPrices?.map((price, index) => (
                          <div
                            className={`wrappedBox ${
                              formValues.selectedPlanIndex === index
                                ? "selected"
                                : ""
                            }`}
                            key={index}
                            onClick={() =>
                              handleSelectPlan(
                                index,
                                price?.plan_price,
                                price?.uid,
                                price
                              )
                            }>
                            <span
                              className="wappedValueLabel"
                              style={{
                                padding: "15px 20px",
                                fontSize: "18px",
                                cursor: "pointer",
                              }}>
                              ₹{convertThenFormat(price?.plan_price || 0)}
                            </span>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <span className="errorMessage m-0">
                        Price Not Available
                      </span>
                    )}

                    <span className="error-label">
                      {formErrors.selectedPrice || ""}
                    </span>
                  </div>
                </>
              )}

              {formValues.selectedExtendedDays?.value ? (
                <div className="formInputBox">
                  <label
                    htmlFor="selectedExtendedDays"
                    className="formInputLabel">
                    Extend Subscription Days
                  </label>

                  <input
                    type="text"
                    name="selectedExtendedDays"
                    ref={assignRef("selectedExtendedDays")}
                    className={`formInput`}
                    value={formValues.selectedExtendedDays.value || 0}
                    disabled
                  />

                  <span className="error-label">
                    {formErrors.selectedExtendedDays || ""}
                  </span>
                </div>
              ) : null}
            </>
          ) : null}

          <div className="formInputBox">
            <label htmlFor="selectedPaymentMode" className="formInputLabel">
              Payment mode <span className="required">*</span>
            </label>

            <div
              className={`commonWrapper ${
                formErrors.selectedPaymentMode ? "formError" : ""
              }`}
              ref={assignRef("selectedPaymentMode")}>
              <SelectDropdown
                options={df_payment_modes}
                selectedOption={formValues.selectedPaymentMode}
                setSelectedOption={(selectedValue) =>
                  onChangeDropdown(selectedValue, "selectedPaymentMode")
                }
                name="Payment Mode"
              />
            </div>

            <span className="error-label">
              {formErrors.selectedPaymentMode || ""}
            </span>
          </div>

          {/* DUAL || CASH || ONLINE */}
          {formValues.selectedPaymentMode?.value === "dual" && (
            <>
              <div className="formInputBox">
                <label htmlFor="cashAmount" className="formInputLabel">
                  Cash amount <span className="required">*</span>
                </label>

                <input
                  type="number"
                  name="cashAmount"
                  ref={assignRef("cashAmount")}
                  className={`formInput ${
                    formErrors.cashAmount ? "formError" : ""
                  }`}
                  placeholder="Enter Cash Amount"
                  value={formValues.cashAmount}
                  onChange={onChangeInput}
                  min={0}
                />

                <span className="error-label">
                  {formErrors.cashAmount || ""}
                </span>
              </div>

              <div className="formInputBox">
                <label htmlFor="onlineAmount" className="formInputLabel">
                  Online amount <span className="required">*</span>
                </label>

                <input
                  type="number"
                  name="onlineAmount"
                  ref={assignRef("onlineAmount")}
                  className={`formInput ${
                    formErrors.onlineAmount ? "formError" : ""
                  }`}
                  placeholder="Enter Online Amount"
                  value={formValues.onlineAmount}
                  onChange={onChangeInput}
                  min={0}
                />

                <span className="error-label">
                  {formErrors.onlineAmount || ""}
                </span>
              </div>
            </>
          )}
          {/* -------------- DUAL || CASH || ONLINE -------------- */}

          {/* PARTIAL || INSTALLMETN */}
          {formValues.selectedPaymentMode?.value === "partial" &&
          formValues.selectedPlan?.info?.is_partial &&
          formValues.selectedPrice?.label &&
          formValues.selectedSubsStartDate ? (
            <>
              <div className="formInputBox">
                <label
                  htmlFor="selectedFirstPartialPaymentMode"
                  className="formInputLabel">
                  First Installment Payment mode{" "}
                  <span className="required">*</span>
                </label>

                <div
                  className={`commonWrapper ${
                    formErrors.selectedFirstPartialPaymentMode
                      ? "formError"
                      : ""
                  }`}
                  ref={assignRef("selectedFirstPartialPaymentMode")}>
                  <SelectDropdown
                    name="Payment Mode"
                    options={partialPaymentModes}
                    selectedOption={formValues.selectedFirstPartialPaymentMode}
                    setSelectedOption={(selectedValue) =>
                      onChangeDropdown(
                        selectedValue,
                        "selectedFirstPartialPaymentMode"
                      )
                    }
                  />
                </div>

                <span className="error-label">
                  {formErrors.selectedFirstPartialPaymentMode || ""}
                </span>
              </div>

              <div className="wFull span4">
                <div className="partial-installments-container">
                  <div className="formInputBox">
                    <label htmlFor="firInsAmount" className="formInputLabel">
                      Enter Amount (Installment 1){" "}
                      <span className="required">*</span>
                    </label>

                    <input
                      type="number"
                      name="firInsAmount"
                      ref={assignRef("firInsAmount")}
                      className={`formInput ${
                        formErrors.firInsAmount ? "formError" : ""
                      }`}
                      placeholder="Enter Amount"
                      value={formValues.firInsAmount}
                      onChange={onChangeInput}
                      disabled
                    />

                    <span className="error-label">
                      {formErrors.firInsAmount || ""}
                    </span>
                  </div>

                  <div className="formInputBox">
                    <label htmlFor="firInsDate" className="formInputLabel">
                      Due Date (Installment 1){" "}
                      <span className="required">*</span>
                    </label>

                    <input
                      type="date"
                      name="firInsDate"
                      ref={assignRef("firInsDate")}
                      className={`formInput ${
                        formErrors.firInsDate ? "formError" : ""
                      } ${formValues.firInsDate ? "date-has-value" : ""}`}
                      value={formValues.firInsDate}
                      onChange={onChangeInput}
                      min={currentMonthCurrentDate}
                      disabled
                    />

                    <span className="error-label">
                      {formErrors.firInsDate || ""}
                    </span>
                  </div>

                  <div className="formInputBox">
                    <label htmlFor="secInsAmount" className="formInputLabel">
                      Enter Amount (Installment 2){" "}
                      <span className="required">*</span>
                    </label>

                    <input
                      type="number"
                      name="secInsAmount"
                      ref={assignRef("secInsAmount")}
                      className={`formInput ${
                        formErrors.secInsAmount ? "formError" : ""
                      }`}
                      placeholder="Enter Amount"
                      value={formValues.secInsAmount}
                      onChange={onChangeInput}
                      disabled
                    />

                    <span className="error-label">
                      {formErrors.secInsAmount || ""}
                    </span>
                  </div>

                  <div className="formInputBox">
                    <label htmlFor="secInsDate" className="formInputLabel">
                      Due Date (Installment 2){" "}
                      <span className="required">*</span>
                    </label>

                    <input
                      type="date"
                      name="secInsDate"
                      ref={assignRef("secInsDate")}
                      className={`formInput ${
                        formErrors.secInsDate ? "formError" : ""
                      } ${formValues.secInsDate ? "date-has-value" : ""}`}
                      value={formValues.secInsDate}
                      onChange={onChangeInput}
                      min={currentMonthCurrentDate}
                      disabled
                    />

                    <span className="error-label">
                      {formErrors.secInsDate || ""}
                    </span>
                  </div>

                  {/* 3rd installment removed — partial payment now supports max 2 installments */}
                </div>
              </div>
            </>
          ) : null}
          {/* -------------- PARTIAL || INSTALLMETN -------------- */}
        </div>
      </form>

      <CloseSubmitBtn
        submitLabel={"Send Payment Link"}
        onSubmit={onSubmit}
        onClose={closeModal}
        isLoading={postPutLoading}
      />
    </div>
  );
};

export default PaymentLinkForm;
